import { useState, useEffect } from "react";
import { Nav, Navbar, Container } from "react-bootstrap";
import navIcon1 from "../assets/git.svg";
import navIcon2 from "../assets/linkedin.svg";
import navIcon3 from "../assets/email.svg";
import { HashLink } from "react-router-hash-link";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  return (
    <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
      <Container className="nav-container">
        <Navbar.Brand href="/home">
          {/* <h1>Vicheda N.</h1> */}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={HashLink} smooth to="/#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>
              About
            </Nav.Link>
            {/* <Nav.Link as={HashLink} smooth to="/#about" className={activeLink === 'about' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('about')}>
              About
            </Nav.Link> */}
            {/* <Nav.Link as={HashLink} smooth to="/#experience" className={activeLink === 'experience' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('experience')}>
              Experience
            </Nav.Link> */}
            <Nav.Link as={HashLink} smooth to="/#projects" className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('projects')}>
              Projects
            </Nav.Link>
            <Nav.Link as={HashLink} smooth to="/#leadership" className={activeLink === 'leadership' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('leadership')}>
              Leadership
            </Nav.Link>
            {/* <Nav.Link as={HashLink} to="/photography" className={activeLink === 'photography' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('photography')}>
              Photography
            </Nav.Link> */}
            {/* <Nav.Link as={HashLink} smooth to="#skills" className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')}>
              skills
            </Nav.Link> */}
          </Nav>
          <span className="navbar-text">
            <div className="social-icon">
              <a href="https://github.com/vicheda" target="_blank">
                <img src={navIcon1} alt="" />
              </a>
              <a href="https://www.linkedin.com/in/vichedanarith/" target="_blank">
                <img src={navIcon2} alt="" />
              </a>
              <a href="mailto:vichedanarith2027@u.northwestern.edu">
                <img src={navIcon3} alt="" />
              </a>
            </div>
            <HashLink smooth to="#connect" className={activeLink === 'connect' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('connect')}>
              <button className="vvd">
                <span>Let’s Connect</span>
              </button>
            </HashLink>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};